module.exports = __webpack_public_path__ + "img/user3.5e7eac55.svg";